import React from 'react';
import config from '../../configuration';
import SimpleLogo from '../../assets/img/logo_other_way_around.png';
import HighlightedLogo from '../../assets/img/logo_other_way_around_highlight.png';
// javascript plugin used to create scrollbars on windows

const ratingTone = ({ p, m, n }) => {
  try {
    p = parseInt(p);
    m = parseInt(m);
    n = parseInt(n);
    if ((isNaN(p) || p === 0) && (isNaN(m) || m === 0) && (isNaN(n) || n === 0)) throw new Error('no rating');
    const overall = (p + m * 0 + (n * -1)) / (p + m + n);
    if (Math.abs(overall) > 0.2) {
      return config.ratingColors[overall > 0 ? 1 : '-1'];
    } else {
      return config.ratingColors[0];
    }
  } catch (error) {
    return 'transparent';
  }
};

const RatingDot = props => {
  const size = props.width ? { width: props.width, height: props.width } : {};
  const color = ratingTone(props.ratings) === 'transparent' ? 'transparent' : (props.noColor ? config.colors.primary : ratingTone(props.ratings));
  return (
    <>
      {
      props.big
        ? (
          <div style={{ position: 'relative', cursor: 'pointer' }} onClick={props.onClick}>
            <div
              className='rating-dot'
              style={{ ...size, ...props.style, position: 'absolute', right: -50, top: 0, backgroundColor: color, display: color === 'transparent' ? 'none' : null }}
            />
            {props.highlighted ? <img src={HighlightedLogo} width={50} /> : <img src={SimpleLogo} width={50} />}
          </div>
          )
        : (
          <i className='fa fa-star' style={{ color: props.highlighted ? '#18F218' : 'yellow', fontSize: props.highlighted ? 14 : null, cursor: 'pointer' }} onClick={props.onClick} />
          )
    }
      {/* <div
            className='rating-dot'
            style={{ ...size, ...props.style, position: 'absolute' }}
            onClick={props.onClick}
          /> */}

    </>
  );
};

export default RatingDot;
